module.exports = __webpack_public_path__ + "static/media/prequal-landing.f346b71e.svg";